import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './SubNav.scss'

import SubNavSection from './SubNavSection'
import AppBanner from './AppBanner'
import { Expand } from 'components/Transitions'

import { connect } from 'react-redux'
import { appListRequest, installedAppListRequest } from '../../actions'

class SubNav extends React.Component {
	componentWillMount() {
		const { appListRequest, installedAppListRequest } = this.props

		appListRequest()
		installedAppListRequest()
	}

	render() {
		const { match, app } = this.props
		const appSubPath = path => '/apps/' + match.params.appId + '/' + path

		return (
			<div styleName="external-wrapper">
				<Expand>
					<div styleName={'navbar'}>
						<div styleName="wrapper">
							<AppBanner app={app} />

							<div styleName="sub-nav-overflow">
								<div styleName="sub-nav-wrapper">
									<SubNavSection
										path={appSubPath('')}
										exact={true}
										label={'Overview'}
										icon={'show_chart'}
									/>
									<SubNavSection
										path={appSubPath('display')}
										label={'Display'}
										icon={'brush'}
									/>
									<SubNavSection
										path={appSubPath('authorization')}
										label={'Authorization'}
										icon={'lock'}
									/>
									<SubNavSection
										path={appSubPath('features')}
										label={'Features'}
										icon={'extension'}
									/>
									<SubNavSection
										path={appSubPath('distribution')}
										label={'Distribution'}
										icon={'apps'}
									/>
								</div>
							</div>
						</div>
					</div>
				</Expand>
			</div>
		)
	}
}

SubNav.propTypes = {}

const mapStateToProps = (state, ownProps) => ({
	app: state.apps.items[ownProps.match.params.appId] || { name: '' }
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	appListRequest: () => {
		dispatch(appListRequest())
	},
	installedAppListRequest: () => {
		dispatch(installedAppListRequest())
	}
})

const ConnectedSubNav = connect(mapStateToProps, mapDispatchToProps)(
	CSSModules(SubNav, styles)
)

export default ConnectedSubNav



// WEBPACK FOOTER //
// ./src/components/Navigation/SubNav.js